import * as React from 'preact/compat'
import cn from 'classnames'
import Modal from "../Modal";
import buttonsCss from '../../../css/v9/buttons.pcss.json'
import questionCss from '../../../css/v9/pages/question.pcss.json'
import Api from "../../api";
import { showToast } from "../toast";

interface PropTypes {
  commentId: number,
  onClose: () => void,
}

// noinspection JSUnusedGlobalSymbols
export default class CommentMarkAsAnswerModal extends React.Component<PropTypes, {}> {

  markAsAnswer = () => {
    Api.post<{
      success: boolean
    }>({
      url: 'faq/mark-as-answer',
      body: {
        commentId: this.props.commentId
      }
    })
      .then((result) => {
        if (result.success) {
          window.location.reload()
        } else {
          showToast({
            type: 'error',
            text: 'Не удалось закрыть вопрос'
          })
        }
      })
      .catch(() => {
        showToast({
          type: 'error',
          text: 'Не удалось закрыть вопрос'
        })
      })
  }

  render() {
    return <Modal onClose={this.props.onClose} showClose>
      <div className={questionCss['confirm-modal']}>
        <h1>Отметить комментарий с решением вопроса</h1>
        <span className={questionCss['confirm-modal__inner-text']}>
          После подтверждения вопрос будет<br/>закрыт автоматически.
        </span>
        <button
          type="button"
          className={cn(buttonsCss['button'], buttonsCss['secondary'])}
          style='--button-padding-left: 24px; --button-padding-right: 24px; --button-icon-size: 24px'
          onClick={this.markAsAnswer}
        >
          Отметить как решение
        </button>
      </div>
    </Modal>
  }
}
